<template>
  <div>
    <div>
      <v-stepper v-model="el">
        <v-stepper-header>
          <v-stepper-step step="1" color="#76cee6">Choose Your upload Invoice file</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" color="#64b0d7">Confirm Your Invoice data</v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" color="#083a95">Summary Information</v-stepper-step>
        </v-stepper-header>

        <v-divider class="my-custom-divider"></v-divider>

        <v-stepper-content step="1" class="pa-0">

          <v-container container--fluid grid-list-md>
            <InVoicesUploadHeader
              :key="keyUploader"
              v-on:file-submitted="fileSubmitted"
              v-on:alert="displayDialog"
            ></InVoicesUploadHeader>
            <InvoiceUploadChecker
              v-if="jobId!==null"
              :active="jobId !== null"
              :job-id="jobId"
              v-on:file-checked="fileChecked"
              v-on:alert="displayDialog"
            ></InvoiceUploadChecker>
          </v-container>
        </v-stepper-content>


        <v-stepper-content step="2" class="px-0">
          <v-container container--fluid grid-list-md>
            <v-row justify="center" align="center" fill height>
              <v-col cols="12">
                <InvoiceUploadConfirmation
                  v-if="el===2"
                  :data-table-props="dataTableProps"
                  :job-id="jobId"
                  v-on:back-to-upload="backToUpload"
                  v-on:file-confirmed="fileConfirmed"
                ></InvoiceUploadConfirmation>

              </v-col>
              <v-col cols="12">
                <InvoiceUploadChecker
                  v-if="fileCheckerActive"
                  :active="fileCheckerActive"
                  :job-id="jobId"
                  v-on:file-checked="fileFinalChecked"
                ></InvoiceUploadChecker>
              </v-col>
            </v-row>
          </v-container>
        </v-stepper-content>

        <v-stepper-content step="3">
          <InvoiceSummary :results="results"></InvoiceSummary>
        </v-stepper-content>


        <v-dialog
          v-model="dialog"
          max-width="500px"
        >
          <v-card>
            <v-card-title>
              ALERT
            </v-card-title>
            <v-card-text>
              {{dialogMessage}}
            </v-card-text>
            <v-card-actions class="justify-center">
              <v-btn
                color="blue darken-1"
                text
                @click="dialog=false">
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-stepper>
    </div>
  </div>
</template>

<script>
import InVoicesUploadHeader from "../../util/Invoices/InVoicesUploadHeader.vue";
import InvoiceUploadChecker from "../../util/Invoices/InvoiceUploadChecker.vue";
import InvoiceUploadConfirmation from "../../util/Invoices/InvoiceUploadConfirmation.vue";
import InvoiceSummary from "../../util/Invoices/InvoiceSummary.vue";
import axios from "axios";

export default {
  name: "InvoiceUpload",
  components: {
    InVoicesUploadHeader,InvoiceUploadConfirmation, InvoiceUploadChecker, InvoiceSummary
  },
  data() {
    return {
      file: '',
      el: 1,
      jobId: null,
      dataTableProps: {
        rejected: [],
        processed:[]
      },
      keyUploader: 0,
      dialogMessage: null,
      dialog: false,
      results: [],
      fileCheckerActive: false,
    }
  },
  methods: {
    backToUpload() {
      this.jobId = null;
      this.dataTableProps = null;
      this.keyUploader++;
      this.el = 1;
    },
    fileSubmitted(job_id) {
      this.jobId = job_id;
      this.$vuetify.goTo(9999, {duration: 1000});

      // jump to next for test
      //this.el = 2;
    },
    fileChecked() {
      // this is pass test
      axios.get(process.env.API_URL + '/invoices/' + this.jobId + '/results')
        .then((response) => {
          this.dataTableProps = response.data;
          this.el = 2;
        })
        .catch((response) => {
          console.log(response.data.error);
        });


   // for test no api
   //  this.jobId = 2;
   //  this.el = 2;
   //  axios.get(process.env.API_URL + '/invoices/' + this.jobId + '/upload')
   //    .then((response) => {
   //      this.dataTableProps = response.data;
   //      this.el = 2;
   //    })
   //    .catch((response) => {
   //      console.log(response.data.error);
   //    })
     },

    fileConfirmed() {
      this.el = 3;
      axios.post(process.env.API_URL + '/invoices/' + this.jobId + '/confirm')
        .then((response) => {
          this.jobId = response.data.job_id;
           this.fileCheckerActive = true;
          this.$vuetify.goTo(9999, {duration: 1000});
        })
        .catch((response) => {
          this.displayDialog(response.response.data.error);
        })
    },
    displayDialog(message) {
      this.dialogMessage = message;
      this.dialog = true;
    },
    fileFinalChecked() {
      axios.get(process.env.API_URL + '/invoices/' + this.jobId + '/results')
        .then((response) => {
          this.results = response.data.processed;
          //this.el++
         })
        .catch((response) => {
          this.displayDialog('ERROR ' + response.response.data.error);
        })
    }

  }
}
</script>

<style scoped>
.my-custom-divider {
  height: 20px;
  background-color: lightblue;
}

</style>






// WEBPACK FOOTER //
// src/components/pages/Manage/InvoicesUpload.vue